import { i18n } from 'platform-lib-app';
export default [
  {
    path: '/globalPartner/station',
    name: 'station',
    component: () => import('./station/index.vue'),
    meta: {
      name: i18n.t('common_web_329'),
      keepAlive: true,
    }
  },
];
